import { iposRoutes } from "../../../../routes/RoutesMap";

export const INDEX_PATH: string = iposRoutes.INDEX.createLink();
export const ACQUISITION_FLOW_MSISDN_PATH: string = iposRoutes.ACQUISITION_FLOW_MSISDN.createLink();
export const ACQUISITION_FLOW_PLAN_PATH: string = iposRoutes.ACQUISITION_FLOW_PLAN.createLink();
export const ACQUISITION_FLOW_OPTIONS_PATH: string = iposRoutes.ACQUISITION_FLOW_OPTIONS.createLink();
export const ACQUISITION_FLOW_ICCID_PATH: string = iposRoutes.ACQUISITION_FLOW_ICCID.createLink();
export const ACQUISITION_FLOW_CONTACT_INFO_PATH: string = iposRoutes.ACQUISITION_FLOW_CONTACT_INFO.createLink();
export const ACQUISITION_FLOW_SUMMARY_PATH: string = iposRoutes.ACQUISITION_FLOW_SUMMARY.createLink();